<div class="product-availability-current-product" [class.container-v2]="!isDesktopLgUp()">
  <sd-product-compact-title [product]="product()"></sd-product-compact-title>
  <sd-product-compact-price [product]="product()"></sd-product-compact-price>
  <sd-add-to-cart [product]="product()"></sd-add-to-cart>
</div>
